import { Navigate } from 'react-router';
import { Seo } from '../components/seo';
import { RequisitesCard } from '../components/requisites-card';
import { useLocale, useT } from '../i18n/locale-context';
import { countryConfig } from '../country';
import { ES_LEGAL_PATHS, hasEsLegalSet } from '../content/legal/es/paths';

// MiLicita (`es`): the operator is AI CRM Inc, named in the Aviso legal — the
// Uzbek operator's requisites must never render there.
const ES_LEGAL = hasEsLegalSet(countryConfig.code);

/** /requisites — company legal + bank details (e-commerce disclosure). Public. */
export function Requisites() {
  const t = useT();
  const { locale } = useLocale();
  if (ES_LEGAL) return <Navigate to={ES_LEGAL_PATHS.avisoLegal} replace />;

  return (
    <div className="mx-auto max-w-[820px]">
      <Seo
        title={t('requisites.pageTitle')}
        description={t('requisites.subtitle')}
        canonical="/requisites"
        lang={locale}
      />

      <h1 className="mb-1 font-brand text-[24px] font-extrabold tracking-[-0.3px] text-ink">
        {t('requisites.pageTitle')}
      </h1>
      <p className="mb-6 text-[14px] text-ink-soft">{t('requisites.subtitle')}</p>

      <RequisitesCard />

      <p className="mt-6 text-[12.5px] leading-[1.6] text-ink-muted">{t('requisites.note')}</p>
    </div>
  );
}
